import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DisplayHtmlContentCommonModel } from '../models/common.model';
import { DisplayHtmlContentCommonComponent } from '../components/display-html-content-common/display-html-content-common.component';

@Injectable()
export class CommonService {
  public isInternetConnectivityMessageDisplay = false;
  message: string = "";
  isEmptyList: any;
  constructor(private _toasterService: ToastrService,
    public _dialog: MatDialog,
    public dialog: MatDialog) {
  }

  /**
   * Show error message
   * @param  {} body
   * @param  {} title=''
   */
  toasterErrorMessage(body: string, title = '') {
    if (this.isInternetConnected()) {

      if (title == undefined || title == null || title == '')
        title = 'Error';
      body = this.capitalizeFirstLetter(body);
      if (body.charAt(body.length - 1) != ".") {
        body = body + ".";
      }
      this._toasterService.error(body, title, {
        enableHtml: true
      });
    }
  }

  /**
 * Check model is empty or not
 * @param obj
 */
  isEmptyObject<T>(obj: T): boolean {
    if (obj !== undefined && obj != null)
      return false;
    return true;
  }

  /**
 * Check if string is empty or not
 * @param obj
 */
  isEmptyString(obj: string) {
    if (obj !== undefined && obj != null && obj != '')
      return false;
    return true;
  }

  /**
   * Show success message
   * @param  {} body
   * @param  {} title=''
   */
  toasterSuccessMessage(body: string, title = '') {
    if (title == undefined || title == null || title == '')
      title = 'Success';
    body = this.capitalizeFirstLetter(body);
    if (body.charAt(body.length - 1) != ".") {
      body = body + ".";
    }
    this._toasterService.success(body, title, {
      enableHtml: true
    });
  }

  /**
   * Show warning message
   * @param  {} body
   * @param  {} title=''
   */
  toasterWarningMessage(body: string, title = '') {
    if (title == undefined || title == null || title == '')
      title = 'Warning';

    this._toasterService.warning(body, title, {
      enableHtml: true
    });
  }

  /**
    * Show informational message
    * @param  {} body
    * @param  {} title=''
    */
  toasterInfoMessage(body: string, title = '') {
    if (title == undefined || title == null || title == '')
      title = 'Info';

    this._toasterService.info(body, title, {
      enableHtml: true
    });
  }

  /**
  * check if internet is connected or not
  */
  public isInternetConnected(): boolean {
    if (navigator.onLine == false) {
      if (!this.isInternetConnectivityMessageDisplay) {
        this.displayInternetUnavailablityPopup();
        this.isInternetConnectivityMessageDisplay = true;
      }
      return false;
    }
    return true;
  }

  /**
   * show popup if internet is disconnected
   */
  public displayInternetUnavailablityPopup(): void {
    let popupModel = new DisplayHtmlContentCommonModel();
    popupModel.content = "No internet connection, Please check your internet connectivity and try again!";
    popupModel.title = "Internet Unavailable";
    popupModel.closeButtonText = "Close";

    this._dialog.open(DisplayHtmlContentCommonComponent, {
      width: '500px',
      height: 'auto',
      data: popupModel
    }).afterClosed().subscribe(response => {
      this.isInternetConnectivityMessageDisplay = false;
    });
  }

  /**
 * Capitalize first letter
 * @param string
 */
  capitalizeFirstLetter(string: string) {
    if (string != undefined)
      return string.charAt(0).toUpperCase() + string.slice(1);
    else
      return string;
  }

  /**
   * Convert string "null", null, undefined, or empty string to actual null value
   * This is useful for handling API responses that return string "null" instead of actual null
   * @param value - The value to parse
   * @returns null if value is "null", null, undefined, or empty string, otherwise returns the original value
   */
  parseNullValue(value: any): any {
    if (value === "null" || value === null || value === undefined || value === "") {
      return null;
    }
    return value;
  }

  formatDateToUTC(date: any): string | null {
    if (!date) return null;

    const d = new Date(date);
    return new Date(
      Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds())
    ).toISOString();
  }

  getTodayStart(): Date {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
    return start;
  }

  getTodayEnd(): Date {
    const now = new Date();
    now.setHours(23, 59, 59, 999);
    return now;
  }

  toLocalISOString(date: Date): string {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${date.getMilliseconds().toString().padStart(3, '0')}Z`;
  }

}

